import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loader from "../../../components/Loader";
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import paginationFactory from "react-bootstrap-table2-paginator";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
// UI Components
import { toastr } from "react-redux-toastr";
import { Container, Card, CardBody, Alert } from "reactstrap";
import { campaignOnOffTableSchema } from "./campaignOnOffTableSchema";
import Header from "./Header";

import {
  getCampaignsOnOff,
  updateCampaignOnOff,
} from "../../../state/actions/campaignOnOffActions";

const RECORDS_PER_PAGE = "campaignOnOffRecordsPerPage";

const CampaignOnOff = ({
  loading,
  campaignOnOffList,
  getCampaignsOnOff,
  updateCampaignOnOff,
  user,
}) => {
  const [recordsPerPage] = useState(localStorage.getItem(RECORDS_PER_PAGE) || 50);
  const [uniqueCompanyCode, setUniqueCompanyCode] = useState([]);
  const [uniqueType, setUniqueType] = useState([]);
  const [uniqueSubType, setUniqueSubType] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("ALL");
  const [selectedType, setSelectedType] = useState([]);
  const [selectedSubType, setSelectedSubType] = useState([]);
  const [screenTableData, setSreenTableData] = useState([]);

  useEffect(() => {
    getCampaignsOnOff();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let companyCodeList = getUnique(campaignOnOffList, "company_code").map((data) => {
      return { label: data.company_code, value: data.company_code };
    });
    companyCodeList.unshift({ label: "ALL", value: "" });
    setUniqueCompanyCode(companyCodeList);
  }, [campaignOnOffList]);

  useEffect(() => {
    let typeList = getUnique(campaignOnOffList, "type").map((data) => {
      return { label: data.type, value: data.type };
    });
    setUniqueType(typeList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    let subTypeList = getUnique(campaignOnOffList, "subtype", selectedType).map((data) => {
      return { label: data.subtype, value: data.subtype };
    });
    setUniqueSubType(subTypeList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueType, selectedType]);

  useEffect(() => {
    let typeCodes, subTypeCodes; //&& selectedCompanyCode.length > 0 && selectedCompanyCode[0] === "";
    let filteredData = campaignOnOffList || [];
    if (
      selectedCompanyCode &&
      !/ALL/gi.test(selectedCompanyCode) &&
      !/ALL/gi.test(selectedCompanyCode.label)
    ) {
      let company_code = selectedCompanyCode.value;
      filteredData = filteredData.filter((item) => company_code === item.company_code);
    }
    typeCodes =
      selectedType && selectedType.length > 0 ? selectedType.map((item) => item.value) : [];
    subTypeCodes =
      selectedSubType && selectedSubType.length > 0
        ? selectedSubType.map((item) => item.value)
        : [];

    if (typeCodes && typeCodes.length > 0) {
      filteredData = filteredData.filter((record) => typeCodes.includes(record.type));
    }
    if (subTypeCodes && subTypeCodes.length > 0) {
      filteredData = filteredData.filter((record) => subTypeCodes.includes(record.subtype));
    }
    setSreenTableData(filteredData);
  }, [campaignOnOffList, selectedCompanyCode, selectedType, selectedSubType]);

  const getUnique = (arr, comp, filter = []) => {
    if (comp === "subtype" && filter) {
      let filterDefinitions = [];
      for (let index = 0; index < filter.length; ++index) {
        let data = filter[index];
        filterDefinitions.push(data.value ? data.value.toLowerCase() : data.toLowerCase());
      }
      filterDefinitions = new Set(filterDefinitions);
      arr = arr.filter((d) => filterDefinitions.has(d.type.toLowerCase()));
    }

    let unique = arr
      .map((e) => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  };

  const LoaderSection = () => {
    if (loading) return <Loader />;
    return null;
  };

  const channelUpdateDialog = (channelType, campaignTemplate) => {
    if (!campaignTemplate || ["sms", "voice", "email"].indexOf(channelType) < 0) {
      //console.log("Invalid Channel Option / Template passed");
      return;
    }
    if (campaignTemplate[channelType] === 0) {
      toastr.confirm(
        `Sorry, that is not a valid option. 
         Please make sure you have selected the correct option and try again.`,
        {
          disableCancel: true,
          okText: "OK",
          onOk: () => {
            //console.log("Ok Clicked");
          },
        }
      );
      return;
    }

    let enableDisable;
    let patchObject = { id: campaignTemplate.id, user_id_bint: user.user_id_bint };

    switch (channelType) {
      case "voice":
        enableDisable = campaignTemplate.voice === 1 ? "disable" : "enable";
        break;
      case "sms":
        enableDisable = campaignTemplate.sms === 1 ? "disable" : "enable";
        break;
      case "email":
        enableDisable = campaignTemplate.email === 1 ? "disable" : "enable";
        break;
      default:
        return;
    }
    patchObject[channelType] = campaignTemplate[channelType] === 1 ? -1 : 1;
    let commentText = `Are you sure you want to ${enableDisable} ${channelType.toUpperCase()} option? Click 'Confirm' to proceed or 'Cancel' to go back.`;
    toastr.confirm(commentText, {
      okText: `Confirm`,
      onCancel: () => {
        console.log("Operation Cancel");
      },
      onOk: () => {
        updateCampaignOnOff(patchObject);
      },
    });
  };

  return (
    <Container
      fluid
      className="p-0"
      id="CampaignBootstrapContainer"
      key="CampaignBootstrapContainer"
    >
      <Header />
      <Card>
        <CardBody>
          <Alert color="warning" className="alert-outline">
            <div className="alert-icon">
              <FontAwesomeIcon icon={faBell} size="lg" className="align-middle" />
            </div>

            <div
              className="alert-message"
              style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            >
              <h4 className="alert-heading">Reminder</h4>
              Note: Voice, SMS and Email messages that are in queue will still be processed. Also,
              all stopped messages will not receive a disposition and will not be recorded in the
              results files.
            </div>
          </Alert>
        </CardBody>
        <CardBody>
          <div className="container-fluid p-0">
            <div className="row">
              <div className="col-lg">
                {"Company:   "}
                <Select
                  onChange={(filter) =>
                    setSelectedCompanyCode(filter || { label: "ALL", value: "ALL" })
                  }
                  options={uniqueCompanyCode}
                  value={selectedCompanyCode}
                />
              </div>
              <div className="col-lg">
                {"Type:   "}
                <Select
                  isMulti
                  onChange={(filter) => setSelectedType(filter || [])}
                  options={uniqueType}
                  value={selectedType}
                  isClearable={false}
                />
              </div>
              <div className="col-lg">
                {"Sub Type:   "}
                <Select
                  isMulti
                  onChange={(filter) => setSelectedSubType(filter || [])}
                  options={uniqueSubType}
                  value={selectedSubType}
                  isClearable={false}
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <LoaderSection />
      {!loading && (
        <>
          <Card>
            <CardBody>
              <BootstrapTable
                id="CampaignBootstrapTable"
                key="CampaignBootstrapTable"
                bootstrap4
                hover
                classes="table-responsive-md"
                keyField="id"
                data={screenTableData || []}
                columns={campaignOnOffTableSchema(channelUpdateDialog)}
                bordered={false}
                pagination={paginationFactory({
                  sizePerPage: Number(recordsPerPage),
                  sizePerPageList: [5, 10, 25, 50, 75, 100],
                  onSizePerPageChange: (sizePerPage) => {
                    localStorage.setItem(RECORDS_PER_PAGE, sizePerPage);
                  },
                })}
              />
            </CardBody>
          </Card>
        </>
      )}
    </Container>
  );
};

CampaignOnOff.propTypes = {
  loading: PropTypes.bool.isRequired,
  campaignOnOffList: PropTypes.array.isRequired,
  getCampaigns: PropTypes.func.isRequired,
  updateCampaign: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.campaignOnOff.loading.campaign || state.campaignOnOff.loading.saving,
  campaignOnOffList: state.campaignOnOff.list,
  user: state.user.user,
});

export default connect(mapStateToProps, {
  getCampaignsOnOff,
  updateCampaignOnOff,
})(CampaignOnOff);
